import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RegistroGenerico, RegistroProtocollo, RegistroRiproduzioni, RegistroUnico } from '../models/registriRequest.model';
import { RegistroColumn } from '../models/registro-column.model';

@Component({
  selector: 'app-register-result-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-table styleClass="p-datatable-gridlines p-datatable-striped" [value]="data()" id="pdfTablePrime" [scrollable]="scrollable()" [scrollHeight]="scrollHeight()" #pdfTablePrime>
      <ng-template pTemplate="header">
        <!-- <tr class="hidden-header">
          <th *ngFor="let col of columns" [style.width]="col.width || 'auto'"></th>
        </tr> -->
        <!-- 'Riproduzioni' -->
        @if (registerType().startsWith('RI')) {
        <tr>
          <th></th>
          <th style="text-align: center" colspan="2">ESTREMI DELLA RICHIESTA</th>
          <th style="text-align: center">ORGANO RICHIEDENTE</th>
          <th style="text-align: center" colspan="5">ESTREMI DEL DOCUMENTO RIPRODOTTO</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        }
        @else if(registerType().startsWith('CI')) {
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th style="text-align: center" colspan="5">Carico</th>
          <th style="text-align: center" colspan="2">Resituzione</th>
          <th style="text-align: center" colspan="2">Distruzione</th>
          <th></th>
          <th></th>
        </tr>
        }
        <tr>
          @for (col of columns(); track col.field) {
          <th [style.width]="col.width || 'auto'" style="text-align: center">{{col.header}}</th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [ngStyle]="{'text-decoration': getTextDecoration(row)}">
          @for (col of columns(); track col.field) {
            @switch (col.pipe) {
              @case ('Date') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]=" row[col.field] | date:'dd/MM/yyyy'"></td>
              }
              @case ('ReplaceTilde') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="row[col.field] | replaceTilde"></td>
              }
              @case ('HighlightDistrutto') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="row[col.field] | replaceTilde | highlightDistrutto"></td>
              }
              @case ('LineThrough') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="row[col.field] | lineThrough"></td>
              }
              @case ('Barred') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="row[col.field] | barred"></td>
              }
              @case ('NoZero') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="(row[col.field] != 0) ? row[col.field] : ''"></td>
              }
              @case ('FirmaDistrutto') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="(row['distrutta'] && row['distrutta'] === true ? 'DISTRUTTO': row[col.field])"></td>
              }
              @case ('Trasmesso') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="'Trasmesso formalmente'"></td>
              }@case ('Note') {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="row[col.field] | formatLongNote"></td>
              }
              @default {
            <td class="vertical-align-top" [style.text-align]="col.align" [style.font-size]="(col.fontSize ?? 10) + 4 + 'px'" [innerHTML]="row[col.field]"></td>
              }
            }
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
  <tr>
    @for (col of columns(); track col.field) {
      <td>&nbsp;</td>
    }
  </tr>
</ng-template>
    </p-table>
  `
})

export class RegisterResultTableComponent {
  data = input.required<RegistroGenerico[]>();
  columns = input.required<RegistroColumn[]>();
  registerType = input.required<string>();
  scrollable = input<boolean>(false);
  scrollHeight = input<string | undefined>();

  getTextDecoration(row: RegistroGenerico) {
    if ((row as RegistroProtocollo).annullato || (row as RegistroRiproduzioni).distrutta
      || ((row as RegistroUnico).posizioneArchivio && (row as RegistroUnico).posizioneArchivio.indexOf('Protocollo annullato') > -1)) {
      return 'line-through';
    }

    return 'none';
  }
}
